import '../assets/content.css';
import { jsx as o } from "react/jsx-runtime";
import { Portal as s, Content as c } from "@radix-ui/react-popover";
import m from "clsx";
import { forwardRef as f } from "react";
const a = "_popover_content_67fdj_3", i = {
  popover_content: a
}, l = f((t, e) => {
  const { className: r, sideOffset: n = 8, ...p } = t;
  return /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(
    c,
    {
      ...p,
      ref: e,
      sideOffset: n,
      className: m(i.popover_content, r)
    }
  ) });
});
l.displayName = "Popover.Content";
export {
  l as PopoverContent
};
